// extracted by mini-css-extract-plugin
export var content = "u6d7EawMdOyJUiWYvmqH";
export var footer = "qQkkrYMn8n5rNCvTuVDe";
export var heading = "pxJJKg6xzj7sTNQ5PKIw";
export var leftColumnItem = "h2HdFqaN9Uc0Fu4wvhfF";
export var rightColumnItem = "c0tkZFKfy6qHfKD8I_NY";
export var root = "P5dEdmUErnKFYdK7RFnf";